// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-gif {
    width: 150px;
    height: 150px;
    position: fixed;
    top: 50%; 
    left: 50%;    
}


.loading-gif-full {
    width: 150px;
    height: 150px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -64px;
    margin-left: -64px;  
}

.loading-div-full {    
    position: absolute;
    inset: 0px;
    background-color: rgb(246, 246, 246);
    color: rgb(255, 255, 255);
    z-index: 9999;     
}

/* Estilo para el fondo semitransparente que cubre toda la pantalla */
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Color de fondo semitransparente */
    z-index: 9999; /* Coloca el fondo por encima de otros elementos */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  /* Estilo para el contenedor del componente de carga */
  .loading-div {
    width: 150px;
    height: 150px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000; /* Coloca el componente Loading por encima del fondo */
  }
  
  /* Estilo para la imagen de carga (ajusta según tus necesidades) */
  .loading-gif {
    width: 100px;
    height: 100px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Loading/loading.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,QAAQ;IACR,SAAS;AACb;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oCAAoC;IACpC,yBAAyB;IACzB,aAAa;AACjB;;AAEA,qEAAqE;AACrE;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,oCAAoC;IAC1E,aAAa,EAAE,kDAAkD;IACjE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,sDAAsD;EACtD;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc,EAAE,sDAAsD;EACxE;;EAEA,kEAAkE;EAClE;IACE,YAAY;IACZ,aAAa;EACf","sourcesContent":[".loading-gif {\n    width: 150px;\n    height: 150px;\n    position: fixed;\n    top: 50%; \n    left: 50%;    \n}\n\n\n.loading-gif-full {\n    width: 150px;\n    height: 150px;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    margin-top: -64px;\n    margin-left: -64px;  \n}\n\n.loading-div-full {    \n    position: absolute;\n    inset: 0px;\n    background-color: rgb(246, 246, 246);\n    color: rgb(255, 255, 255);\n    z-index: 9999;     \n}\n\n/* Estilo para el fondo semitransparente que cubre toda la pantalla */\n.loading-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5); /* Color de fondo semitransparente */\n    z-index: 9999; /* Coloca el fondo por encima de otros elementos */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  /* Estilo para el contenedor del componente de carga */\n  .loading-div {\n    width: 150px;\n    height: 150px;\n    border-radius: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 10000; /* Coloca el componente Loading por encima del fondo */\n  }\n  \n  /* Estilo para la imagen de carga (ajusta según tus necesidades) */\n  .loading-gif {\n    width: 100px;\n    height: 100px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
